import React from 'react';
import { Check } from 'lucide-react';

interface MobilePackCardProps {
  name: string;
  price: string;
  features: string[];
  isPopular?: boolean;
  onClick?: () => void;
}

const MobilePackCard: React.FC<MobilePackCardProps> = ({
  name,
  price,
  features,
  isPopular = false,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-2xl p-4 shadow-sm border transition-all duration-200 active:scale-95 ${
        isPopular
          ? 'border-amber-300 shadow-amber-100'
          : 'border-gray-100'
      }`}
    >
      {/* Badge Popular */}
      {isPopular && (
        <div className="inline-block px-3 py-1 bg-gradient-to-r from-amber-500 to-amber-600 text-white text-xs font-semibold rounded-full mb-3">
          ⭐ Populaire
        </div>
      )}

      {/* Header */}
      <h3 className="text-lg font-bold text-gray-900 mb-1">{name}</h3>
      <div className="flex items-baseline gap-1 mb-3">
        <span className="text-2xl font-bold bg-gradient-to-r from-amber-600 to-amber-500 bg-clip-text text-transparent">
          {price}
        </span>
        <span className="text-xs text-gray-500">CFA</span>
      </div>

      {/* Features - Tous affichés */}
      <ul className="space-y-2 mb-4">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-2">
            <Check className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
            <span className="text-xs text-gray-700">{feature}</span>
          </li>
        ))}
      </ul>

      {/* CTA Button */}
      <button
        className={`w-full py-2.5 rounded-xl font-medium text-sm transition-all duration-200 ${
          isPopular
            ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-white shadow-sm hover:shadow-md'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        Choisir ce pack
      </button>
    </div>
  );
};

export default MobilePackCard;
